import React from 'react';
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import { useTranslate } from 'react-admin';

const i18nBase = 'resources.scheduled-jobs';

export interface NotificationDetailsDialogProps {
  notification: Record<string, unknown> | null;
  onClose: () => void;
}

export const NotificationDetailsDialog: React.FC<
  NotificationDetailsDialogProps
> = ({ notification, onClose }) => {
  const translate = useTranslate();

  return (
    <Dialog
      open={notification !== null}
      onClose={onClose}
      fullWidth
      maxWidth="md"
    >
      <DialogTitle
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Typography variant="h6" sx={{ fontWeight: 600 }}>
          {translate(`${i18nBase}.dialog.notificationDetails`)}
        </Typography>
        <IconButton onClick={onClose} size="small" aria-label="close">
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers>
        <Box
          component="pre"
          sx={{
            m: 0,
            p: 2,
            bgcolor: 'grey.50',
            borderRadius: 1,
            fontSize: 13,
            fontFamily:
              'ui-monospace, Menlo, Monaco, "Courier New", monospace',
            whiteSpace: 'pre-wrap',
            wordBreak: 'break-word',
            maxHeight: '60vh',
            overflowY: 'auto',
          }}
        >
          {notification ? JSON.stringify(notification, null, 2) : ''}
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default NotificationDetailsDialog;
